import { css, unsafeCSS } from 'lit';
import {sbkCoreBreakpointLg} from '@/tokens/variables.js'

const breakpointLg = unsafeCSS(`${sbkCoreBreakpointLg}`);

export const style = css`

    :host {
        --textarea-border-radius-default: var(--_textarea-border-radius-default, var(--sbkInputBorderRadiusDefault));
        --textarea-border-on-light-enabled: var(--_textarea-border-on-light-enabled, var(--sbkInputBorderOnLightEnabled));


        --gap-small-inputs: var(--sbkInputXs, 0.5rem);
        --gap-large-small-inputs: var(--_gap-large-small-inputs, var(--sbkInput4xs));
        --gap-annotation-counter: var(--_gap-annotation-counter, var(--sbkInput4xs));
        --gap-annotation-text-counter: var(--_gap-annotation-text-counter, var(--sbkInput3xs));
        --gap-icons-text-area: var(--_gap-icons-text-area, var(--sbkInput3xs));

        --input__color: var(--_input__color, var(--sbkInputFgColorOnLightDefault));
        --input__color--disabled: var(--_input__color--disabled, var(--sbkInputFgColorOnLightDisabled));
        --input__color--error: var(--_input__color--error, var(--sbkInputFgColorOnLightError));

        --input__bg: var(--_input__bg, var(--sbkInputBgColorOnLightEnabled));
        --input__bg--active: var(--_input__bg--active, var(--sbkInputBgColorOnLightActive));
        --input__bg--hover: var(--_input__bg--hover, var(--sbkInputBgColorOnLightHover));
        --input__bg--focus: var(--_input__bg--focus, var(--sbkInputBgColorOnLightFocus));
        --input__bg--disabled: var(--_input__bg--disabled, var(--sbkInputBgColorOnLightDisabled));
        --input__bg--error: var(--_input__bg--error, var(--sbkInputBgColorOnLightError));

        --input__border: var(--_input__border, var(--sbkInputBorderOnLightEnabled));
        --input__border--active: var(--_input__border--active, var(--sbkInputBorderOnLightActive));
        --input__border--disabled: var(--_input__border--disabled, var(--sbkInputBorderOnLightDisabled));
        --input__border--error: var(--_input__border--error, var(--sbkInputBorderOnLightError));
        --input__border--focus: var(--_input__border--focus, var(--sbkInputBorderOnLightFocus));
        --input__border--hover: var(--_input__border--hover, var(--sbkInputBorderOnLightHover));
        --input__border--readonly: var(--_input__border--readonly, var(--sbkInputBorderOnLightDisabled));

    }

    :host(.hide) {
        display: none;
    }

    .input__wrapper {
        margin-bottom: var(--sbkCoreSpacingMd);

        .label__wrapper + sbk-annotation {
            margin-top: calc(var(--sbkInput3xs) * -1);
            margin-bottom: var(--sbkInput3xs);
        }
    }


    :host([error]) textarea {
        border: var(--sbkInputBorderOnLightError);
    }

    .input__wrapper--error {
        color: var(--input__color--error);

        .textarea {
            background-color: var(--input__bg--error);
            border: var(--input__border--error);
        }
    }

    .textarea {
        background-color: var(--input__bg);
        border-radius: var(--textarea-border-radius-default);
        border: var(--input__border);
        color: var(--input__color);
        outline: transparent;
        outline-offset: var(--sbkInputBorderGapFocus);
        font: var(--sbkInputSmallTextSm);
        padding: var(--sbkInput2xs);
        resize: vertical;
        width: 100%;

        @media all and (min-width: ${breakpointLg}) {
            font: var(--sbkInputLargeTextLg);
            padding: var(--sbkInputXs);
        }

        &:active {
            background-color: var(--input__bg--active);
            border: var(--input__border--active);
        }

        &:focus {
            background-color: var(--input__bg--focus);
            outline: var(--input__border--focus);
        }

        @media (hover: hover) and (pointer: fine) {
            &:hover:not(:focus) {
                background-color: var(--input__bg--hover);
                border: var(--input__border--hover);
            }
        }

        &[disabled] {
            background-color: var(--input__bg--disabled);
            border: var(--input__border--disabled);
            color: var(--input__color--disabled);
        }

        &[readonly] {
            background-color: var(--input__bg--disabled);
            border: var(--input__border--readonly);
            color: var(--input__color--disabled);
        }
    }

`;
